import React, { useEffect, useState } from "react";
import "../../Registration/MainRegister/mainRegister.css";
import "../LoginWithMPIN/loginWithMPIN.css";
import axios from "../../../axios";
import SetNewMPIN from "./SetNewMPIN";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function LoginWithOTP({ setVerifyUser }) {
  const contactNo = JSON.parse(localStorage.getItem("Mobile_no"));
  const schoolCode = localStorage.getItem("schoolCode");
  const schoolAssignedId = localStorage.getItem("schoolAssignedId");
  const emailId = JSON.parse(localStorage.getItem("Email"));
  const [verify, setVerify] = useState("email");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [showGetOtp, setShowGetOtp] = useState(true);
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [isVailidatedEmail, setIsValidatedEmail] = useState({});
  const [timeDisplay, setTimeDisplay] = useState(false);
  const [isWait, setIsWait] = useState(false);
  const [userLogin, setUserLogin] = useState({
    Otp: "",
    forgotMpin: false,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  //  this useEffect for remove invalid otp error when  otp time out error
  useEffect(() => {
    if (minutes === 0 && seconds === 0) {
      setIsValidatedEmail("");
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [seconds, minutes]);

  const handleGetOtpClick = async () => {
    setIsWait(true);
    try {
      if (verify === "mobile") {
        // await axios.post("/api/v1/teacherAuth/generateMobileOtp", {
        //   mobile_number: contactNo,
        // });
      } else {
        await axios.post("/api/v1/teacherAuth/generateEmailOtp", {
          school_assigned_id: schoolAssignedId,
          school_code: schoolCode,
        });
      }
      setIsWait(false);
      setShowGetOtp(false);
      setShowResendOtp(true);
      //Here increase otp time limit
      setMinutes(2);
      setSeconds(60);
      setTimeDisplay(true);
      setIsValidatedEmail("");
      setUserLogin({ Otp: "" });
    } catch (error) {
      // Handle the error appropriately (e.g., show an error message to the user)
      console.error("Error sending OTP:", error);
    } finally {
      setIsWait(false);
    }
  };

  const handleResendOtpClick = async () => {
    setIsWait(true);
    try {
      if (verify === "mobile") {
        // {/* Here commented code is part of hide mobile OTP option */}
        // await axios.post("/api/v1/teacherAuth/generateMobileOtp", {
        //   mobile_number: contactNo,
        // });
      } else {
        await axios.post("/api/v1/teacherAuth/generateEmailOtp", {
          school_assigned_id: schoolAssignedId,
          school_code: schoolCode,
        });
      }
      setIsWait(false);
      setShowGetOtp(false);
      setShowResendOtp(true);
      setMinutes(2);
      setSeconds(60);
      setUserLogin({ Otp: "" });
      setIsValidatedEmail("");
    } catch (error) {
      // Handle the error appropriately (e.g., show an error message to the user)
      console.error("Error resending OTP:", error);
    } finally {
      setIsWait(false);
    }
  };

  // verify otp js

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (verify === "mobile") {
        const res1 = await axios.post(`/api/v1/teacherAuth/validateMobileOtp`, {
          mobile_otp: userLogin.Otp,
          mobile_number: contactNo,
        });
        res1 &&
          setUserLogin({
            ...userLogin,
            forgotMpin: true,
          });
      } else {
        console.log(userLogin.Otp);
        const res2 = await axios.post(`/api/v1/teacherAuth/validateEmailOtp`, {
          email_otp: userLogin.Otp,
          email_id: emailId,
        });
        res2 &&
          setUserLogin({
            ...userLogin,
            forgotMpin: true,
          });
      }
    } catch (error) {
      setIsValidatedEmail(error.response.data);
    }
  };
  const MaskedEmail = (email) => {
    const maskEmail = (email) => {
      if (!email || typeof email !== "string") return email;

      const [localPart, domain] = email.split("@");
      if (!localPart || !domain) return email;

      // Mask local part
      const firstPart = localPart.slice(0, 2);
      const maskedLocalMiddle = "*".repeat(Math.max(localPart.length - 4, 5));
      // const lastPart = localPart.slice(-1);

      // Mask domain
      const [domainName, domainExtension] = domain.split(".");
      const maskedDomainMiddle = "*".repeat(Math.max(domainName.length - 2, 3));
      // const firstDomainPart = domainName.slice(0, 1);
      const lastDomainPart = domainName.slice(-1);

      const maskedDomain = `${maskedDomainMiddle}${lastDomainPart}.${domainExtension}`;

      return `${firstPart}${maskedLocalMiddle}@${maskedDomain}`;
    };

    return <span>{maskEmail(email)}</span>;
  };

  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const phoneStr = phone.toString();

    // Show first 2 and last 2 digits
    return (
      phoneStr.slice(0, 2) +
      "*".repeat(phoneStr.length - 4) +
      phoneStr.slice(-2)
    );
  };
  return (
    <div className="TotalContainer">
      <div className="MainContainer col-12 p-0  d-md-flex ">
        <div className="banner_box col-md-3 col-12 p-0">
          <img
            className="banner_img "
            src="/Register-img/baner_img.jpg"
            alt="register img"
          ></img>
        </div>
        {/* Here add back button on forget pin */}
        <FontAwesomeIcon
          onClick={() => {
            setVerifyUser(false);
          }}
          icon={faArrowLeft}
          style={{ fontSize: "25px", margin: "10px" }}
        />
        <div className="form_box_loin col-md-9 col-12 p-0 ">
          <div>
            <div className="total_logo_regist">
              <img
                className="logo_registration"
                src="/Register-img/Register_logo.png"
                alt="register logo"
              ></img>
            </div>
            <div className="title_regis">Welcome Back!</div>
            <div className="login_mpin">Forgot PIN</div>

            <div className="d-md-flex mt-2">
              {/* Here commented code for hide mobile OTP option */}
              {/* <div class="form-check mr-3">
                <input
                  onClick={(e) => {
                    setVerify("mobile");
                    setSeconds(0);
                    setShowResendOtp(false);
                    setShowGetOtp(true);
                    setIsValidatedEmail("");
                    setUserLogin({
                      ...userLogin,
                      Otp: "",
                    });
                  }}
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  checked={verify === "mobile"}
                />
                <label
                  class="form-check-label"
                  for="exampleRadios1"
                  className="radio_label"
                >
                  Mobile
                </label>
              </div> */}

              {/* <div class="form-check">
                <input
                  onChange={(e) => {
                    setVerify("email");
                    setSeconds(0);
                    setShowResendOtp(false);
                    setShowGetOtp(true);
                    setIsValidatedEmail("");
                    setUserLogin({
                      ...userLogin,
                      Otp: "",
                    });
                  }}
                  checked={true}
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                />
                <label
                  class="form-check-label"
                  for="exampleRadios1"
                  className="radio_label"
                >
                  Email
                </label>
              </div> */}
            </div>

            <div
              className="bg-white border rounded-4 p-4 mt-2 shadow-sm"
              style={{ borderColor: "#9db3c7" }}
            >
              <form>
                <div className="text-start">
                  <label
                    className="fw-semibold mb-2 d-block"
                    style={{ fontSize: "18px", color: "#4b5563" }}
                  >
                    Mobile Number
                  </label>

                  <div
                    className="border rounded-4 px-2 py-2 fw-medium text-dark"
                    style={{
                      borderColor: "#9db3c7",
                      fontSize: "18px",
                    }}
                  >
                    +91 {maskPhoneNumber(contactNo)}
                  </div>
                  <span style={{ color: "red" }}>
                    {!contactNo && "Mobile number is not registered!!"}
                  </span>
                </div>
                <div className="text-start mt-4">
                  <label
                    className="fw-semibold mb-2 d-block"
                    style={{ fontSize: "18px", color: "#4b5563" }}
                  >
                    Email ID
                  </label>

                  <div
                    className="border rounded-4 px-2 py-2 fw-medium text-dark"
                    style={{
                      borderColor: "#9db3c7",
                      fontSize: "18px",
                    }}
                  >
                    {MaskedEmail(emailId)}
                  </div>
                  <span style={{ color: "red" }}>
                    {!emailId && "Email Id is not registered!!"}
                  </span>
                </div>
                {/* <div className="input_box2 ">
                {verify === "mobile" ? (
                  <div id="myId" className="school_id_mpin" type="number">
                    {" "}
                    {contactNo}{" "}
                  </div>
                ) : (
                  <div id="myId" className="school_id_mpin" type="email">
                    {" "}
                    {emailId}{" "}
                  </div>
                )}
              </div> */}

                <div className="input_box2">
                  {seconds === 0 ? (
                    <input id="myId" disabled={true} />
                  ) : (
                    <input
                      id="myId"
                      maxLength={6}
                      placeholder="Enter OTP"
                      onChange={(e) =>
                        setUserLogin({
                          ...userLogin,
                          Otp: e.target.value,
                        })
                      }
                      value={userLogin.Otp}
                      autocomplete="off"
                    />
                  )}
                  {timeDisplay && (
                    <span className="Login_time_otp">
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </span>
                  )}
                  {showGetOtp && (
                    <p className="get_otp" onClick={handleGetOtpClick}>
                      {isWait ? "Please wait..." : "Get OTP"}
                    </p>
                  )}
                </div>

                <div>
                  <div>
                    {isVailidatedEmail.status === false && (
                      <div className="invailidOtp">Invalid OTP entered</div>
                    )}
                  </div>

                  {minutes === 0 && seconds === 0 && showResendOtp === true && (
                    <div className="invailidOtp">OTP Timed out</div>
                  )}
                </div>

                <input
                  id={
                    (!minutes && !seconds) || userLogin.Otp.length !== 6
                      ? "btn_disabled"
                      : "main_login_btn"
                  }
                  type="submit"
                  className="btn btn-primary my-3"
                  value="Continue"
                  //Here I added logic for enable continue button
                  disabled={
                    userLogin.Otp.length !== 6 ||
                    !userLogin.Otp ||
                    (seconds === 0 && minutes === 0)
                  }
                  onClick={handleSubmit}
                />
              </form>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <div className="Resend_verifyOtp">
                {showResendOtp && seconds === 0 && minutes === 0 && (
                  <p onClick={handleResendOtpClick}>
                    {isWait ? "Please wait..." : "Resend OTP"}
                  </p>
                )}
              </div>
            </div>

            {/* <div className="mt-4 d-flex justify-content-center ">
                            <span style={{ color: '#003354', fontSize: '14px', marginTop: '2px' }}>Not John deo?</span>&nbsp;
                            <Link className="link" to='/'> <span style={{ color: " #000A11", fontSize: '14px', cursor: "pointer" }}>Login with different account</span></Link>
                        </div> */}
          </div>
        </div>
      </div>
      {userLogin.forgotMpin && <SetNewMPIN />}
    </div>
  );
}
